<template>
      <div class="box mt-20">
        <div class="box-header">
          <!-- <h3>선택정보 입력</h3> -->

          <h4>입실 체크리스트 관리</h4>
          <!-- <p>차량정보, 기타 요청사항을 입력하세요</p> -->
          <small>방문 예약 시, 방문 전 체크리스트 및 입실 시 체크리스트 목록 관리가 가능합니다.</small>
          <div class="pt-16 pb-7">
            <button class="btn btn-md line-2 mr-6" @click="add()">추가</button>
            <button class="btn btn-md line-2 mr-6" @click="edit()" :disabled="!enableEditButton">수정</button>
          </div>
        </div>


        <div class="box-body pt-0">
          <div class="box-tbl mt-0">
            <table class="tbl no-outline no-shadow">
              <colgroup>
                <col width="42px">
                <col width="200px">
                <col width="auto">
                <col width="auto">
                <col width="150px">
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <label class="md-check">
                      <input type="checkbox" class="has-value" v-model="checkAll">
                      <i class="blue"></i>
                    </label>
                  </th>
                  <th>종류</th>
                  <th>종류 설명</th>
                  <th>내용</th>
                  <th>활성여부</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, index) in checkList" v-bind:key="index">
                  <td>
                    <label class="md-check" v-show="item.index">
                      <input type="checkbox" class="has-value" v-model="item.checked">
                      <i class="blue"></i>
                    </label>
                  </td>
                  <td v-show="!item.isEdit">{{ item.checkType.checkTypeStr}}</td>
                  <td v-show="item.isEdit">
                    <!--input type="text" name="설명" class="form-control" v-model="item.checkType.checkTypeStr"-->
                    <dropdown displayName="display" valueName="value" v-model="item.checkTypeCode" :isDropup="true" :datasource="checkType" title="" :isSelectionFirstData="true" :width="130" @close="updateRow(item)"/>
                  </td>
                  <td v-show="!item.isEdit">{{ item.checkType.checkTypeDescription }}</td>
                  <td v-show="!item.isEdit">{{ item.contents}}</td>
                  <td v-show="item.isEdit" colspan="2"><input type="text" name="설명" class="form-control" v-model="item.contents"></td>
                  <td class="td-compo-box" v-show="!item.isEdit">
                    <dropdown v-model="item.isEnable" displayName="display" valueName="value" :datasource="isEnable" title="" :isSelectionFirstData="true" :width="130" @close="updateItem(item)"/>
                  </td>
                  <td align="center" v-show="item.isEdit">
                    <button class="btn btn-m" @click="upsertItem(item)"><i class="icon-check"></i></button>
                    <button class="btn btn-m ml-5" @click="cancel(item)"><i class="icon-close"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
</template>
<script>
  import PageHeader from '@/layout/PageHeader.vue'
  import dropdown from "@/components/Dropdown.vue"

  export default {
    components: {
      PageHeader,
      dropdown
    },
    watch: {
      checkAll(newVal, oldVal){
        if(newVal != oldVal)
          this.checkList.map(x=>x.checked = newVal)
      }
    },
    data() {
      return {
        tosList: null,
        copyList: null,
        assetList: null,
        checkList: null,
        checkAll: false,
        isEnable: [
          {display: '비활성', value: 0},
          {display: '활성', value: 1}
        ],
        isRequired: [
          {display: '선택', value: 0},
          {display: '필수', value: 1}
        ],
        checkType: null
      }
    },
    created(){

    },
    mounted(){
      this.init();
    },
    computed: {
      // isEdit(){
      //   return (item) =>{
      //     return item.isEdit;
      //   }
      // },
      enableEditButton(){
        if(this.checkList)
          return this.checkList.filter(x => x.index && x.checked).length > 0;
      }
    },
    methods: {
      init(){
        this.getCheckList();
        this.getCheckType();
      },
      getCheckList(){
        this.$http.get('/api/public/checkListAll')
          .then((result) => {
            this.checkList = result.data;
          }).catch((e) =>{
        })
      },
      getCheckType(){
        this.$http.get('/api/public/checkType')
          .then((result) => {
            this.checkType = result.data;
            this.checkType.forEach(x => {
              x.display = x.checkTypeStr;
              x.value = x.checkTypeCode;
            })
          }).catch((e) =>{
        })
      },
      upsertItem(item) {
        if(item.index)
          this.updateItem(item)
        else
          this.insertItem(item);

      },
      insertItem(item){
        this.$http.post('/api/public/checkList', item)
          .then((result) => {
            this.noti('완료','추가되었습니다.', 'success')
            this.getCheckList();
          }).catch((e) =>{
        })
      },
      updateItem(item){
        this.$http.put('/api/public/checkList', item)
          .then((result) => {
            this.noti('완료','수정되었습니다.', 'success')
            this.getCheckList();
          }).catch((e) =>{
        })
      },
      cancel(item){
        if(item.index){
          debugger;
          var restoreItem = this.copyList.filter(x=> x.index == item.index)[0];
          if(restoreItem){
            item.assetStr = restoreItem.assetStr;
            item.assetDescription = restoreItem.assetDescription;
          }
          item.isEdit = false;
          item.checked = false;
        }
        else{
          _.remove(this.checkList, x => x.uuid && x.uuid == item.uuid)
        }
        this.$forceUpdate();
      },
      edit(){
        debugger;
        this.copyList = this.copyNew(this.checkList);
        this.checkList.forEach(x => {
          x.isEdit = x.checked;
        });
        _.remove(this.checkList, x => x.uuid)
        this.$forceUpdate();
      },
      add(){
        this.checkList.forEach(x => {
          x.checked = false;
          if(!x.uuid)
            x.isEdit = false;
        });
        let obj = {
          uuid : this.uuidv4(),
          contents: '',
          isEnable: 1,
          checkTypeCode: 1,
          isEdit: true,
          checkType: {}
        };

        this.checkList.push(obj);
      }
    }
  }
</script>
<style>

</style>
